import bfcm from "../../../assets/shopifyBFCM/bfcm.svg";
import ipad from "../../../assets/shopifyBFCM/ipad.png";
import researchScope from "../../../assets/shopifyBFCM/researchScope.jpg";
import barChart from "../../../assets/shopifyBFCM/bar-chart.svg";
import globe from "../../../assets/shopifyBFCM/globe.svg";
import smartphone from "../../../assets/smartphone.svg";
import pin from "../../../assets/shopifyBFCM/pin.svg";
import home from "../../../assets/home.svg";
import theming from "../../../assets/shopifyBFCM/theming.jpg";
import viz1 from "../../../assets/shopifyBFCM/viz1.jpg";
import viz2 from "../../../assets/shopifyBFCM/viz2.png";
import viz3 from "../../../assets/shopifyBFCM/viz3.png";
import viz4 from "../../../assets/shopifyBFCM/viz4.png";
import orders from "../../../assets/shopifyBFCM/orders.png";
import monospace from "../../../assets/shopifyBFCM/monospace.svg";
import globe1 from "../../../assets/shopifyBFCM/globe-1.png";
import globe2 from "../../../assets/shopifyBFCM/globe-2.png";
import contrast from "../../../assets/shopifyBFCM/contrast.jpg";
import breakpoints from "../../../assets/shopifyBFCM/breakpoints.jpg";
import liveData from "../../../assets/shopifyBFCM/liveData.jpg";
import personalized from "../../../assets/shopifyBFCM/personalized.jpg";
import region from "../../../assets/shopifyBFCM/region.jpg";
import deviceSupport from "../../../assets/shopifyBFCM/deviceSupport.png";
import countdown from "../../../assets/shopifyBFCM/countdown.png";
import billboard from "../../../assets/shopifyBFCM/billboard.png";
import tv from "../../../assets/shopifyBFCM/tv.png";
import merchant from "../../../assets/shopifyBFCM/merchant.png";

export const hero = {
  heading: "Black Friday Cyber Monday Live Globe",
  heroImage1: { path: bfcm, width: "212px" },
  heroImage2: { path: ipad, width: "640px" },
  overview: {
    demoLink:
      "https://investors.shopify.com/news-and-events/press-releases/news-details/2022/Shopify-Merchants-Set-New-Black-Friday-Cyber-Monday-Record-with-7.5-Billion-in-Sales/default.aspx",
    demoText: "Article",
    demoBtnWidthOverride: "149px",
    roles: ["UI Design", "Prototyping"],
    duration: "2 Months",
    team: "Adam Perron, Logan Wright, Matt Vickers, Kenny Law, Petar Bojinov, Levon Cross",
    tools: ["Figma", "Codesandbox", "Spline"],
  },
};

export const designRequirements = {
  heading: "Design Requirements",
  requirements: [
    {
      icon: barChart,
      text: "Allow users to view live data and trends",
    },
    {
      icon: globe,
      text: "Interaction with the globe",
    },
    {
      icon: smartphone,
      text: "Variety of screen sizes and device types",
    },
    {
      icon: pin,
      text: "Impact within user's geographical region",
    },
    {
      icon: home,
      text: "Admin integration",
    },
  ],
};

export const contextSections = [
  {
    heading: "Research and Scope",
    body: "<strong>We started by examining previous globes projects and analyzed the features that we wanted to incorporate into the new experience.</strong> In addition, we had access to an internal tool that showed us feedback provided by users from the previous globe. This research allowed us to identify the necessary data reporting and data freshness requirements for the globe. Engineering worked alongside us to ensure the feasibility of these features.",
    image: researchScope,
  },
  {
    heading: "Alignment",
    body: "Aligning with senior leadership and marketing was crucial for the success of the project. We incorporated the marketing team early on into our design process to ensure that the globe was cohesive with Shopify's overall BFCM messaging. <strong>We placed a strong emphasis on hexagons in our design explorations, but we also explored other design options to ensure that we were considering all possibilities.</strong>",
  },
  {
    heading: "Design",
    body: `We began exploring a wide range of treatments. <strong>As a team, we faced a challenge from both a developer and designer perspective: many of us had not previously worked with 3D.</strong>
    <br>
    <br>
    Initially, we attempted to explore ideas using <strong>3D modeling tools such as Splines and various Figma plugins.</strong> Finally, we experimented with <strong>code sandboxes using Three.js.</strong> Thanks to our awesome developers, we were able to experiment and quickly iterate on stylizing the globe. At first, we were scrappily changing variables, but they set up a menu for us in no time. This made iterating with 3D a lot easier. I must admit, it was pretty enjoyable to mess around with code again. 
    `,
  },
  {
    heading: "Theming Decisions",
    body: "During this phase of the project, we slightly deviated from the marketing brand kit vision. Senior leadership expressed a desire to incorporate more of the hexagon gradient treatment. Together, we decided that the two should complement each other, rather than dictate the appearance of the globe.",
    image: theming,
    caption: "Early Concept",
  },
  {
    heading: "Visualizing the Data",
    body: "No optimize project is complete without a bit of data visualization. One thing that we noticed immediately was that we planned on having many different elements on the globe at once. <strong>We have individual particles, arches and hexagon all representing their own pieces of data.</strong> We went back and forth based on what was available with the 3D libraries we were using, and what made most sense to the data we had access to. Striking a balance between interactivity and readability was a challenge, but we ultimately decided on a few specific solutions. After agreeing on a general theme, we iterated on the density of the hexagons.",
    image: viz1,
    imgGroup: "viz",
    caption:
      "Thanks to our awesome developers we had a “nerd” menu up to play around with the different parts of the globe later into our prototyping phase",
  },
  {
    images: [
      { src: viz2, imgGroup: "viz" },
      { src: viz3, imgGroup: "viz" },
      { src: viz4, imgGroup: "viz" },
    ],
    outerCaption: "Hexagon Density Iterations",
  },
  {
    image: orders,
    imageStyles: { maxWidth: "253px", mb: "-38px" },
    caption: "Legend for Orders in real time",
  },
  {
    heading: "Lives in the Admin",
    body: `While exploring the globe, we also considered how we would be featured in the admin's real-time dashboard. <strong>I was part of the design team for the dashboard, which was receiving an overhaul at the same time.</strong> Juggling the two projects complimented each other well.`,
  },
  {
    heading: "Feedback and changes",
    body: "<strong>We received feedback that the globe was not web accessible, so we toned down the colour treatment</strong>, which was challenging due to the tight timeline and 3D JavaScript library testing abilities. Scope creep occurred due to the tight timeline, and we had to audit the user experience to update the global site with more features. <strong>During testing, visualizing the freight caused a performance dip, so we allowed users to toggle on and off the freight route lines. We also updated the typography used for the numbers to feature monospace for better readability.</strong>",
    image: monospace,
    disableModal: true,
    imageStyles: { maxWidth: [null, "900px"] },
    caption: "Monospace typography introduced for better readability",
  },
  {
    heading: "Addressing accessibility concerns",
    image: contrast,
    caption:
      "Adjusting colours based on contrast and different types of color blindness: Protanopia, Deuteranopia, Tritanopia",
  },
  {
    heading: "Breakpoints",
    body: "One of the challenges we faced was supporting multiple device types. As with web development, an application has to run on screens of all sizes and orientations. With so much information on screen we had to make sure the experience was usable for these edge cases.",
    image: breakpoints,
    caption:
      "Making sure the globe was accessible across niche breakpoints such as mobile-small-landscape",
  },
];

export const shippingFreights = {
  globe1: globe1,
  globe2: globe2,
  caption: "Ability to toggle shipping freight routes",
};

export const infoImages = [
  {
    heading: "Live Data",
    text: "The data includes real-time orders, unique shoppers, sales per minute, and orders per minute.",
    image: liveData,
  },
  {
    heading: "Personalized to your store",
    text: "View live data from your own Shopify store within a real-time dashboard, or view data for all merchants collectively.",
    image: personalized,
  },
  {
    heading: "Check out your region",
    text: "Search for your specific region to see the impact Shopify merchants are making.",
    image: region,
  },
  {
    heading: "Device Support",
    text: "View the data on various devices.",
    image: deviceSupport,
  },
  {
    heading: "Countdown and Wrap Up",
    text: "Before and after BFCM Starts",
    image: countdown,
  },
];

export const solutionSections = [
  {
    heading: "Press Attention",
    body: "Launch was extremely exciting with this project as it was high visibility. Alongside the marketing effort the globe was featured on many billboards across major cities around the world. It was very satisfying seeing something I worked on locally here in Toronto. The globe designs were also featured on many news outlets including CNN!",
  },
  {
    images: [
      {
        src: billboard,
        caption: "The globe on a billboard!",
        imageStyles: { flexShrink: [null, null, null, 0] },
        imgGroup: "press",
      },
      {
        src: tv,
        caption: "On TV!",
        imgGroup: "press",
      },
      {
        src: merchant,
        caption: "In merchant hands",
        imgGroup: "press",
      },
    ],
  },
];
